/**
 * Brand glyph — uses the Olimpia Sensor logo asset.
 * Pass the `logo-on-dark` class to invert it to white over dark backgrounds.
 */
export default function Logo({ className = "h-7 w-7" }) {
  return (
    <img
      src="/brand/logo.png"
      alt="Olimpia Sensor"
      className={`${className} object-contain select-none`}
      draggable="false"
    />
  );
}
